import has from 'lodash/has';
import OAuth2Service from './OAuth2Service';

// function BoxService {
function authenticate(fn, credInfo) {
  const clientId = credInfo['box.client_id'];
  const clientSecret = credInfo['box.client_secret'];
  const oauth2Params = {
    'oauth2.auth_url': 'https://account.box.com/api/oauth2/authorize',
    'oauth2.auth_url_param.client_id': clientId,
    'oauth2.auth_url_param.state': 'security_token%3D138r5719ru3e1',
    'oauth2.auth_url_param.response_type': 'code',

    'oauth2.token_url': 'https://api.box.com/oauth2/token',
    'oauth2.token_url_param.client_id': clientId,
    'oauth2.token_url_param.client_secret': clientSecret,
    'oauth2.token_url_param.grant_type': 'authorization_code',
  };

  const credStaticInfo = {
    'auth.type': 'OAUTH2',
    'oauth2.client.id': clientId,
    'oauth2.client.secret': clientSecret,
    'oauth2.token.type.override': 'Bearer',
    'oauth2.access.token.method': 'POST',
    'oauth2.access.token.url': 'https://api.box.com/oauth2/token',
    'vendor.refresh_url': 'https://api.box.com/oauth2/token',
    'vendor.auth_scheme': 'query',
  };

  return OAuth2Service.authenticate((authInfo, error) => {
    if (authInfo && has(authInfo, 'access_token')) {
      fn({ ...credStaticInfo, ...authInfo }, null);
    } else {
      fn(null, error);
    }
  }, oauth2Params);
}

function createInfoFromAuthResult(authInfo) {
  if (authInfo?.access_token) {
    return {
      'vendor.name': 'box',
      access_token: authInfo.access_token,
      'auth.type': authInfo['auth.type'],
      'oauth2.access.token.method': authInfo['oauth2.access.token.method'],
      'oauth2.access.token.url': authInfo['oauth2.access.token.url'],
      'oauth2.client.id': authInfo['oauth2.client.id'],
      'oauth2.client.secret': authInfo['oauth2.client.secret'],
      'oauth2.token.type.override': authInfo['oauth2.token.type.override'],
      'vendor.refresh_url': authInfo['vendor.refresh_url'],
      'vendor.auth_scheme': authInfo['vendor.auth_scheme'],
      'vendor.access_token': authInfo.access_token,
      'vendor.token_type': authInfo.token_type,
      'vendor.last_refreshed_at': authInfo.authorizedAt,
      'vendor.refresh_token': authInfo.refresh_token,
      'vendor.token_expires_in': authInfo.expires_in,
      'vendor.has_token_expiration_ts': true,
      'vendor.other_info': '{}',
    };
  }
}

export default {
  authenticate,
  createInfoFromAuthResult,
};
